import { apiConfig } from "../config/apiConfig";
import { REGEX } from "../constants/regex";
import { startLoader, stopLoader } from "../util/loader";
import { getBrandDetailsFromBrandJson, getFranchiseWebLocationIdDetails, insertAfterUrl, storeBookingApiPayload } from "../util/share";
import { handleInputError } from "../util/commonValidation";
import { getBrandJSON } from "../util/locationBasedBrandJson";
import { gtmCustomEventLeadFlow } from "../util/gtm-custom-event-lead-flow";
import { contactUsPostCallWrapper } from "../apiCaching/POST-Requests/apiContactCallWrapper";
import { ContactUsPayloadModel } from "../apiCaching/POST-Requests/interface/contact/contactInterface";
import { DomainIdentifier } from "../util/domainService";
import { LocalizationIdentifier } from "../util/localizationService";
import { disclaimerHandleCheck, DisclaimerServiceIdentifier } from "../util/disclaimerService";
import { hideTermsPolicy, toggleTermsPolicyBasedOnCountry } from "../util/hideTermsPolicy";
import { getCountryCode } from "../location-search-map/getCountryCode";
import { attachClearFieldListeners, handleCheckboxChangeUtility, handleHideError } from "../apiCaching/POST-Requests/helperModules/handleBookingSubmit";


export class FormHandlerAskQuestion {
    private static instance: FormHandlerAskQuestion;
    
    private form: HTMLFormElement | null = null;
    private readonly askQuestionFormService!: NodeListOf<HTMLElement>;

    private  nameInput: HTMLInputElement;
    private  lastInput: HTMLInputElement;
    private  phoneNumberInput: HTMLInputElement;
    private  emailInput: HTMLInputElement;
    private  zipCodeInput: HTMLInputElement;
    private commentTextInput: HTMLInputElement;
    private businessNameTextInput: HTMLInputElement;
    private errorMessage: { businessErrorName: string };

    private validateNotes: boolean = false;
    private validateBusiness: boolean = false;
    private noteWithRequestBody: any;


    private constructor() {
        this.init();
        this.clearFields();
        const parentElement = document.querySelector('.contact-info.ask-question') as HTMLFormElement;
        this.nameInput = parentElement?.querySelector('#send-name') as HTMLInputElement;
        this.lastInput = parentElement?.querySelector('#sendL-name') as HTMLInputElement;
        this.phoneNumberInput = parentElement?.querySelector('#send-phone') as HTMLInputElement;
        this.emailInput = parentElement?.querySelector('#send-email') as HTMLInputElement;
        this.zipCodeInput = parentElement?.querySelector('#send-zip') as HTMLInputElement;
        this.commentTextInput = parentElement?.querySelector('#send-note') as HTMLInputElement;
        this.businessNameTextInput = parentElement?.querySelector('#sendB-name') as HTMLInputElement;
        this.phoneNumberInput = parentElement?.querySelector('#send-phone') as HTMLInputElement;
        if (this.phoneNumberInput) {
            this.phoneNumberInput.addEventListener('input', this.handleMobileInput.bind(this));
        }

        this.askQuestionFormService = document.querySelectorAll('[id*="ask-form-service-reminder"]');
        this.nameInput?.addEventListener('input', this.errorOnName.bind(this))
        this.lastInput?.addEventListener('input', this.errorOnLastName.bind(this))
        this.emailInput?.addEventListener('input', this.emailError.bind(this))
        this.zipCodeInput?.addEventListener('input', this.zipCodeError.bind(this))
        this.zipCodeInput?.addEventListener('focusout', this.handleFocusOut.bind(this));
        this.askQuestionFormService?.forEach((checkbox) => {
            checkbox.addEventListener("change", () => handleCheckboxChangeUtility("#ask-question-form"));
        });
        this.errorMessage = {
            businessErrorName: (document.getElementById('sendB-name-error-msg') as HTMLElement)?.textContent ?? 'Please enter the business name'
        }
        this.checkAndBindErrorFields();

    }

    /**
     * Get the singleton instance of FormHandlerAskQuestion
     * @returns {FormHandlerAskQuestion} The singleton instance
     */
    static getInstance(): FormHandlerAskQuestion {
        if (!FormHandlerAskQuestion.instance) {
            FormHandlerAskQuestion.instance = new FormHandlerAskQuestion();
        }
        return FormHandlerAskQuestion.instance;
    }

    handleFocusOut() {
        const zipCode = this.zipCodeInput?.value.trim();
        DisclaimerServiceIdentifier(zipCode);
        toggleTermsPolicyBasedOnCountry('#ask-question-form', zipCode);
    }

    checkAndBindErrorFields() {
        if (this.commentTextInput) {
            if (this.commentTextInput.hasAttribute("required")) {
                this.commentTextInput?.addEventListener('input', this.errorOnComment.bind(this));
                this.validateNotes = true;
            }
        }
        if (this.businessNameTextInput) {
            if (this.businessNameTextInput.hasAttribute("required")) {
                this.businessNameTextInput?.addEventListener('input', this.errorOnInputFields.bind(this));
                this.validateBusiness = true;
            }
        }

    }

    errorOnName() {
        if (this.nameInput.value !== '' && !REGEX.sendName.test(this.nameInput.value)) {
            const getErrMsg = (document.getElementById(`send-name-error-msg`) as HTMLElement).getAttribute('aria-describedby');
            const fieldError: any = document.getElementById(`send-name-error-msg`);
            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg ?? 'Invalid name format.'

            }
        }
        else {
            this.hideError('send-name')
        }

    }
    errorOnLastName() {
        if (this.lastInput.value !== '' && !REGEX.sendName.test(this.lastInput.value)) {
            const getErrMsg = (document.getElementById(`sendL-name-error-msg`) as HTMLElement).getAttribute('aria-describedby');
            const fieldError: any = document.getElementById(`sendL-name-error-msg`);
            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg ?? 'Invalid Last name format.';
            }
        }
        else {
            this.hideError('sendL-name')
        }

    }
    emailError() {
        if (this.emailInput.value != '' && !REGEX.sendEmail.test(this.emailInput.value)) {
            const getErrMsg = (document.getElementById(`send-email-error-msg`) as HTMLElement).getAttribute('aria-describedby');
            const fieldError: any = document.getElementById(`send-email-error-msg`);


            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg ?? 'Invalid email address, please try again.'

            }
        }
        else {

            this.hideError('send-email')
        }

    }

    private handleMobileInput(e: Event): void {
        e.preventDefault();
        const reg = REGEX.mobileNumberRegex;
        const val = this.phoneNumberInput?.value;
        const phoneMatch = val?.replace(/\D/g, '').match(reg);
        let formattedVal = '';

        if (phoneMatch) {
            const areaCode = phoneMatch[1];
            const mainNumber = phoneMatch[2];
            const optionalDashWithPhoneNumbers = phoneMatch[3] ? '-' + phoneMatch[3] : '';

            formattedVal = `(${areaCode}) ${mainNumber}${optionalDashWithPhoneNumbers}`;
        }
        if (this.phoneNumberInput.value != '' && this.phoneNumberInput?.value.length < 14 && formattedVal.length < 14) {
            const getErrMsg = (document.getElementById(`send-phone-error-msg`) as HTMLElement).getAttribute('aria-describedby');
            const fieldError: any = document.getElementById(`send-phone-error-msg`);


            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg ?? 'Invalid phone format.'

            }
        }
        else {
            this.hideError('send-phone')
        }

        if (phoneMatch) {
            let formattedPhoneNumber;

            if (!phoneMatch[2]) {
                formattedPhoneNumber = phoneMatch[1];
            } else {
                formattedPhoneNumber = `(${phoneMatch[1]}) ${phoneMatch[2]}${phoneMatch[3] ? '-' + phoneMatch[3] : ''}`;
            }

            this.phoneNumberInput!.value = formattedPhoneNumber;
        }

    }

    zipCodeError() {
        if (this.zipCodeInput?.value != '' && !REGEX.sendZip.test(this.zipCodeInput?.value.trim())) {
            const getErrMsg = (document.getElementById(`send-zip-error-msg`) as HTMLElement).getAttribute('aria-describedby');
            const fieldError: any = document.getElementById(`send-zip-error-msg`);


            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg ?? 'Invalid zip code format.'
            }
        }
        else {
            this.hideError('send-zip')
        }
    }
    errorOnComment() {
        if (this.commentTextInput.value == '') {
            const getErrMsg = (document.getElementById(`send-note-error-msg`) as HTMLElement).getAttribute('aria-describedby');
            const fieldError: any = document.getElementById(`send-note-error-msg`);
            if (fieldError) {
                this.commentTextInput?.classList.add('invalid-field')
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg ?? 'Enter a valid inputs'
            }
        }
        else {
            this.hideError('send-note')
        }
    }

    errorOnInputFields() {
        handleInputError(this.businessNameTextInput, 'sendB-name-error-msg', REGEX.matchAny, this.errorMessage.businessErrorName);
    }

    hideError(id: any) {
         handleHideError(id);
    }

    clearFields = () => {
      attachClearFieldListeners(["send-state"]);
    };

    private init() {
        this.form = document.querySelector('#ask-question-form button') as HTMLFormElement;
        const radioElement = document.getElementById('inline-radio-6') as HTMLInputElement;

        if (this.form) {
            this.form.addEventListener('click', this.handleSubmit.bind(this));
            if (radioElement) radioElement.checked = true;
        }
        const localisation = DomainIdentifier();
        const countryCode = getCountryCode();
        const localisedcountryCode = sessionStorage.getItem('countryCode');
        if (localisation === 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca') {
            hideTermsPolicy('#ask-question-form', 'terms-policy-text');
        }
    }

    private async handleSubmit(event: Event): Promise<void> {
        event.preventDefault();
        const formFields = this.getFormFields();
        let host = window.location.hostname.toLowerCase();
        let IsTest;
        if (host.includes('nblysbx') || host.includes('nblydev') || host.includes('nblytest')) {
            IsTest = true;
        } else {
            IsTest = false;
        }
        const conceptId = (document.getElementById('conceptId') as HTMLInputElement)?.value;
        const url = window.location.origin;
        let vendorId;
        try {
            const brandJson = getBrandJSON();
            if (brandJson === 'Error validating Location') {
                console.error("Error Determining BrandJSON path for given location")
            }
            else {
                const apiResponse = await fetch(`${url}/${brandJson}`);
                const apiData = await apiResponse.json();

                const matchingVendor = apiData.find((item: any) => item.id === conceptId);
                if (matchingVendor) {
                    vendorId = matchingVendor.vendorId;
                }
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }

        if (this.validateForm()) {
            const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
            const brandData = await getBrandDetailsFromBrandJson(conceptCode);
            let noteText ='';
            if(brandData.note_text_contactus_api?.length > 0) {
                noteText = brandData.note_text_contactus_api;
            }
            
            if(brandData?.send_ask_question_comments){
                if(noteText){
                    noteText += ` , `;
                }
                noteText +=  brandData?.send_ask_question_comments;
            }

            if(formFields.note){
                if(noteText){
                    noteText += ` , `;
                }
                noteText += formFields.note;
            }
            
            let requestBody: ContactUsPayloadModel = {
                comments:`${noteText}`,
                conceptId: Number(conceptId),
                email: formFields.email,
                firstName: formFields.firstName?.split(' ')[0],
                isLocalized: false,
                isNewCustomer: String(formFields.isSignup ?? false),
                isTest: IsTest,
                lastName: formFields.firstName?.split(' ')[1] ?? '',
                phone: formFields.phoneNumber,
                signUpForUpdates: this.checkForLatestUpdateRadio(),
                zipCode: formFields.zipCode?.trim(),
                vendorId: Number(vendorId),
            };

            try {

                if(this.lastInput) {
                    requestBody.lastName = this.lastInput?.value ?? ''; // If user have authored last name fied then we will pass otherwise we will split first name and take the last name from it.
                    requestBody.firstName = formFields?.firstName;
                }else{
                    const firstName = this.nameInput?.value.split(' ');
                    if(firstName.length > 1){   
                        requestBody.lastName = firstName.splice(-1).join(' ');
                        requestBody.firstName = firstName.join(' ');
                    }
                }
            
                const domain = DomainIdentifier();
                const localisation = LocalizationIdentifier();
                // Default value to pass if checkbox is not found
                let checkboxId = '';
                const countryZip = !REGEX.sendCaPostalCode.test(formFields.zipCode?.trim()) ? 'us' : 'ca';
                if (((domain === "us" && !localisation) || (domain === "us" && localisation=="us")) && countryZip === 'us') {
                    checkboxId = 'ask-form-service-reminder-us';
                } else {
                    checkboxId = 'ask-form-service-reminder-ca';
                }
                const questionForm: any = document.getElementById('ask-question-form')
                this.noteWithRequestBody = disclaimerHandleCheck(false, questionForm, requestBody, requestBody.zipCode, checkboxId);
                requestBody = this.noteWithRequestBody;
              
            } catch (error) {
                console.error('An error occurred in disclaimerHandleCheck in Refer file:', error);
            }

            // Handle FranchiseWebLocation ID
            // If available, set isLocalized to true as per our requirement.
            if(!brandData?.send_ask_question_value) {
                const franchiseId = await getFranchiseWebLocationIdDetails(formFields.zipCode?.trim());
                if (franchiseId) {
                    requestBody.franchiseWebLocationId = Number(franchiseId);
                    requestBody.isLocalized = true;
                }
            }
            
            if (formFields?.businessName) {
                requestBody.companyName = formFields.businessName;
            }
            if(brandData?.send_ask_question_value) {
                requestBody.formType = brandData?.send_ask_question_value;
            }
            
            startLoader();
            contactUsPostCallWrapper(apiConfig.CONTACT_US_SEND, requestBody).then((response: any) => {
                    stopLoader();
                    const submitObj = {
                        event: 'opus_form_submit_ev',
                        status: 'success'
                    }
                    gtmCustomEventLeadFlow(submitObj);
                    storeBookingApiPayload(requestBody, response);
                    const forms = document.getElementById('ask-question-form');
                    if (forms) {
                        forms.parentElement?.classList.add('hidden');
                    }

                    const cont = document.getElementById('confirmation');
                    if (cont) cont.classList.remove('hidden');
                    insertAfterUrl();
                    if (document.getElementById('whitepaperdoc')) {
                        const url: any = document.getElementById('whitepaperdoc');

                        // Create a download link.
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url?.value;
                        a.download = 'downloaded.pdf'; // You can set the desired filename here.
                        a.target = "_blank"
                        document.body.appendChild(a);
                        a.click();
                    }
                })
                .catch((err) => {
                    stopLoader();
                    const submitObj = {
                        event: 'opus_form_submit_ev',
                        status: 'failure'
                    }
                    gtmCustomEventLeadFlow(submitObj);
                    const forms = document.getElementById('ask-question-form');
                    if (forms) {
                        forms.parentElement?.classList.add('hidden');
                    }

                    const cont = document.getElementById('failure');
                    if (cont) cont.classList.remove('hidden');
                });
        } else {
            // stopLoader()
        }
    }

    private getFormFields(): any {
        const fields = {
            firstName: this.nameInput?.value,
            zipCode: this.zipCodeInput?.value,
            phoneNumber: this.phoneNumberInput?.value,
            email: this.emailInput?.value,
            customerType: this.getSelectedRatio(document.getElementsByName('inline-radio-cust')),
            contactMethod: this.getSelectedRatio(document.getElementsByName('inline-radio-method')),
            note: this.commentTextInput?.value ?? '',
            isSignup: (document.querySelector('input[name="inline-radio-tips"]') as HTMLInputElement)?.checked,
            businessName: this.businessNameTextInput?.value,
            lastName: this.lastInput?.value,
        };
        if (this.lastInput?.value) {
            fields.lastName = this.lastInput?.value;
        }
        return fields;
    }
    private checkForLatestUpdateRadio(): boolean {
        if ((document.getElementById('inline-radio-6') as HTMLInputElement)?.checked) {
            return true;
        }
        return false;
    }

    private getSelectedRatio(node: any): string | null {
        const radioButtons = node;
        for (const radioButton of radioButtons) {
            if ((radioButton as HTMLInputElement).checked) {
                const labelElement = document.querySelector(`[for="${radioButton.id}"]`) as HTMLElement;
                const label = labelElement.innerText;
                return label;
            }
        }
        return null;
    }


    private validateForm(): boolean {
        const formFields = this.getFormFields();
        document.querySelectorAll('.invalid-field').forEach((e) => e.classList.remove('invalid-field'));
        const errors: any = {};

        if (formFields.firstName === '' && this.nameInput?.required) {
            errors['send-name'] = '';
        } else if (formFields.firstName && !REGEX.sendName.test(formFields.firstName)) {
            errors['send-name'] = 'Invalid name format.';
        }

        if (formFields?.lastName === '' && this.lastInput?.required) {
            errors['sendL-name'] = '';
        } else if (formFields?.lastName && !REGEX.sendName.test(formFields?.lastName)) {
            errors['sendL-name'] = 'Invalid Last name format.';
        }

        if (formFields.zipCode === '' && this.zipCodeInput?.required) {
            errors['send-zip'] = '';
        } else if (formFields.zipCode && !REGEX.sendZip.test(formFields.zipCode?.trim()) || formFields.zipCode === '00000') {
            errors['send-zip'] = 'Invalid zip code format.';
        }

        if (formFields.phoneNumber === '' && this.phoneNumberInput?.required) {
            errors['send-phone'] = '';
        } else if (formFields.phoneNumber && formFields.phoneNumber.length < 14) {
            errors['send-phone'] = 'Invalid phone format.';
        }
        if (this.validateNotes && formFields.note === '') {
            errors['send-note'] = '';
        }

        if (formFields.email === '' && this.emailInput?.required) {
            errors['send-email'] = '';
        } else if (formFields.email && !REGEX.sendEmail.test(formFields.email)) {
            errors['send-email'] = 'Invalid email format.';
        }

        if (this.validateBusiness && formFields.businessName === '') {
            errors['sendB-name'] = '';
        } else if (formFields.businessName && !REGEX.matchAny.test(formFields.businessName)) {
            errors['sendB-name'] = this.errorMessage?.businessErrorName;
        }

        const errorIdChekboxSpan = handleCheckboxChangeUtility("#ask-question-form");
        if (errorIdChekboxSpan) {
            errors[errorIdChekboxSpan] = '';
        }

        Object.keys(errors).forEach((fieldId, index) => {
            const field: any = document.getElementById(fieldId);
            const fieldError: any = document.getElementById(`${fieldId}-error-msg`);
            if (field?.parentNode) {
                const errorMessage = errors[fieldId];
                const errorElement = document.createElement('span');
                errorElement.className = 'error-msg';
                errorElement.id = `${fieldId}-error-msg`;
                errorElement.textContent = errorMessage;
                field.classList.add("invalid-field");
                if (fieldError?.classList.contains('hidden'))
                    fieldError.classList.remove('hidden')
            }
            if (index === 0 && field) {
                field.focus();
            }
        });

        return Object.keys(errors).length === 0;
    }
}

if (!(globalThis as any).__AskQuestionFormListenerAdded) {
  (globalThis as any).__AskQuestionFormListenerAdded = true;

  document.addEventListener('DOMContentLoaded', () => {
    if ((globalThis as any).__AskQuestionFormInitialized) return;

    const askFormSection = document.querySelector('#ask-question-form');
    if (askFormSection) {
      (globalThis as any).__AskQuestionFormInitialized = true;
      FormHandlerAskQuestion.getInstance();
    }
  });
}
